<template>
  <div>
    <input :id="id" type="file" class="d-none" @change="previewImg"  /> 
    <label :for="id" class="wrap-image w-100 d-flex align-items-end justify-content-center" ref="wrapImage"
      :class="[
        {[`mb-${mb}`]: mb}
      ]"
      :style="[
        {height: height},
        [src ? {backgroundImage: [`url(${src})`], border: 'unset'} : '']
      ]">
      <button v-if="withRemove" type="" class="btn bg-dark btn-remove"><i class="fas fa-times"></i></button>
      <slot>
          <i v-if="!src && isThumbnail" class="fas fa-image"></i>
          <span v-if="!src && isThumbnail" class="fw-bold">Add Image Here</span>

          <i v-if="!src && !isThumbnail" class="fas fa-plus"></i>
      </slot>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    isThumbnail: {
      type: Boolean,
      default: false
    },
    h: {
      type: String,
      default: '0'
    },
    mb: {
      type: Number,
      default: 0
    },
    withRemove: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      height: this.h,
      src: ''
    }
  },
  mounted() {
    console.log(this.height)
    if (this.height == 0) {
      let width = this.$refs.wrapImage.clientWidth
      // console.log(width)
      this.height = width> 0 ? width + 'px' : '100%'
    }
  },
  methods: {
    previewImg(e) {
      const file = e.target.files[0];
      this.src = URL.createObjectURL(file)
      console.log(URL.createObjectURL(file))
    }
  }
}
</script>

<style>

</style>